import {Base} from "./base";

class DocService extends Base {
  constructor() {
    super();
  }

  /**
   * 医生名片
   * @param docId
   * @returns {Promise<{}>}
   */
  async card(docId, needToken = true) {
    const {code, obj = {}} = await this.$http('nethos.doc.card', {docId, needToken});
    return code === '0' ? obj : {};
  }

  /**
   * 医生公告
   * @param docId
   * @returns {Promise<void>}
   */
  async noticeGet(docId) {
    await this.$http('nethos.doc.notice.get', {docId})
  }

  /**
   * 医生/团队评价
   * @param pageSize
   * @param pageNo
   * @param docId
   * @param moudleType
   * @param moudleId
   * @param searchType content|time
   * @returns {Promise<void>}
   */
  async comment({pageSize = 10, pageNo = 1, docId, searchType, moudleType, moudleId, ...options}) {
    const {code, list = [], paginator = {}} = await this.$http('nethos.doc.comment.list', {
      pageSize,
      pageNo: options.pageNum,
      docId,
      searchType,
      moudleId,
      moudleType
    });
    return code === '0' ? {list, paginator} : {list: [], paginator: {}};
  }

  /**
   * 线上续方价格
   * @param docId
   * @returns {Promise<void>}
   */
  async consultBillFee(docId) {
    const {obj} = await this.$http('nethos.doc.consult.bill.fee', {
      docId
    });
    return obj
  }

  async isFollow(docId) {
    const {obj = {}} = await this.$http('nethos.follow.get', {
      docId
    }, {}, {
      showError: false
    });
    return obj;
  }

  async follow(docId) {
    const {code} = await this.$http('nethos.follow.dp.add', {docId});
    return code === '0';
  }

  async unfollow(docId) {
    const {code} = await this.$http('nethos.follow.cancel', {docId});
    return code === '0'
  }

  /**
   * 医生文章详情
   * @returns {Promise<void>}
   */
  async articleDetail(articleId) {
    const {obj = {}} = await this.$http('nethos.doc.article.detail', {
      articleId
    })
    return obj;
  }

  /**
   * 医生发布
   * @param options
   * @param options.pageNo
   * @param options.pageSize
   * @returns {Promise<{list,paginator}>}
   */
  async articleIndexList(options) {
    const {list = [], paginator = {}} = await this.$http('nethos.doc.article.index.list', options);
    return {list, paginator}
  }

  /**
   * 医院列表
   * @returns {Promise<[]>}
   */
  async hosList() {
    const {list = []} = await this.$http('nethos.doc.hos.list', {});
    return list;
  }


  /**
   * 校验是否精神科医生
   * @param docId
   * @returns {Promise<boolean>}
   */
  async psychiatryDepartment(docId) {
    const {obj = false} = await this.$http('nethos.doc.psychiatry.department', {docId});
    return obj;
  }

  /**
   * 医生详情
   * @param docId
   * @returns {Promise<void>}
   */
  async details(docId) {
    await this.$http('nethos.doc.detail', {docId})
  }


  /**
   * 扫码专属二维码
   * @param exclusiveCodeId
   * @returns {Promise<{}>}
   */
  async exclusiveCodeScanGet(exclusiveCodeId) {
    const {obj = {}} = await this.$http('nethos.doc.exclusive.code.scan.get', {exclusiveCodeId});
    return obj;
  }

  /**
   * PK榜医生列表
   * @param options
   * @param options.searchType
   * @param options.searchDate
   * @param options.anonymousId
   * @returns {Promise<[]>}
   */
  async rankList(options) {
    const {list = []} = await this.$http('nethos.doc.rank.list', options);
    return list;
  }

  /**
   * 匿名id
   * @returns {Promise<string>}
   */
  async rankGetAnonymous() {
    const {obj = ""} = await this.$http('nethos.doc.rank.get.anonymous', {});
    return obj
  }

  /**
   * 点赞、取消点赞
   * @param options
   * @param options.rankLikeId
   * @param options.isLike
   * @param options.anonymousId
   * @returns {Promise<void>}
   */
  async rankLike(options) {
    const {code} = await this.$http('nethos.doc.rank.like', options);
    return code;
  }

  /**
   * 年度报告获取
   * @param options
   * @param options.searchYear
   * @param options.token
   * @param options.searchType
   * @returns {Promise<{}>}
   */
  async annualReport(options) {
    const {obj = {}} = await this.$http('nethos.doc.annual.report', options);
    return obj;
  }


  /**
   * 生成年度报告登录
   * @param options
   * @param options.docMobile
   * @param options.captcha
   * @param options.cid
   * @returns {Promise<String>}
   */
  async captchaReportLogin(options) {
    const {token = ''} = await this.$http('nethos.doc.captcha.report.login', options)
    return token;
  }

  /**
   * 长期咨询服务列表
   * @param docId
   * @return {Promise<[]>}
   */
  async serveList(docId) {
    const {list = []} = await this.$http('nethos.personal.serve.list', {docId})
    return list;
  }


  /**
   * 长期咨询服务详情
   * @param consultId
   * @return {Promise<{}>}
   */
  async serveInfoDetails(consultId) {
    const {obj = {}} = await this.$http('nethos.personal.serve.info.details', {
      consultId
    });
    return obj;
  }

  /**
   * 获取全科医生服务包
   * @param doctorId
   * @returns {Promise<{}>}
   */
  async packages(doctorId) {
    const {obj = {}} = await this.$http('smarthos.card.info.doc.serve', {
      doctorId
    });
    return obj
  }
}

export const docService = new DocService();



// WEBPACK FOOTER //
// ./src/services/doc.js